<script>
    import WebSVG from "$/assets/images/Web.svg";
    import KindleSVG from "$/assets/images/Kindle.svg";
    import UploadPDF_SVG from "$/assets/images/UploadPDF.svg";
    import RibbonSVG from "$/assets/images/Ribbon.svg";
    import { clickAction } from "$/utils/clickAction";
    import { goto } from "@roxi/routify";

    import { onMount } from "svelte";

    import { checkIfExtensionInstalled } from "$/utils/Utils";
    import { GlobalSearchStore } from "$/stores/GlobalSearchStore";
    import { redirect } from "@roxi/routify";
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { ActiveTopic } from "$/stores/extension/ActiveTopicStore";

    let isExtensionInstalled = true;

    onMount(async () => {
        isExtensionInstalled = await checkIfExtensionInstalled();
    });

    function navigateToPDF() {
        const basePath = window.location.origin;
        $redirect(`${basePath}/pdf`);
    }

    function navigateToKindle() {
        window.location.href = `https://read.amazon.com/notebook#${ServiceConsts.TOPIC_PARAM_NAME}=${$ActiveTopic.id}`;
    }

    function handleClick(action) {
        if (isExtensionInstalled && action === "webSearch") {
            GlobalSearchStore.openSearchModal(true);
        } else if (isExtensionInstalled && action === "kindleImport") {
            navigateToKindle();
        }
    }
</script>

<div class="buttons-container">
    <div
        class="button"
        use:clickAction={() => handleClick("webSearch")}
        class:disabled={!isExtensionInstalled}
    >
        {#if !isExtensionInstalled}
            <img src={RibbonSVG} alt="Extension Needed" class="ribbon" />
        {/if}

        <div class="button__icon">
            <img src={WebSVG} alt="Web Icon" class="svg-icon" />
        </div>
        <div class="button__text">Search the Web</div>
    </div>
    <div class="button" use:clickAction={navigateToPDF}>
        <div class="button__icon">
            <img src={UploadPDF_SVG} alt="Upload PDF Icon" class="svg-icon" />
        </div>
        <div class="button__text">Upload PDF</div>
    </div>
    <div
        class="button"
        use:clickAction={() => handleClick("kindleImport")}
        class:disabled={!isExtensionInstalled}
    >
        {#if !isExtensionInstalled}
            <img src={RibbonSVG} alt="Extension Needed" class="ribbon" />
        {/if}

        <div class="button__icon">
            <img src={KindleSVG} alt="Kindle Icon" class="svg-icon" />
        </div>
        <div class="button__text">Import from Kindle</div>
    </div>
</div>

<style>
    @import "../../main.css";

    .buttons-container {
        @apply flex flex-col justify-center gap-4 pt-6 sm:flex-row;
    }

    .button {
        @apply relative flex h-24 w-48 cursor-pointer flex-col items-center justify-center overflow-clip rounded-xl border border-gray-200 transition-all hover:scale-105 hover:shadow-md;
    }

    .button__icon {
        @apply flex h-full w-full items-center justify-center bg-gray-100 text-gray-300;
    }

    .svg-icon {
        @apply h-8 w-14 text-gray-400;
    }

    .button__icon svg {
        @apply h-10 w-10;
    }

    .button__text {
        @apply p-2 text-xs;
    }

    .ribbon {
        @apply absolute -right-6 -top-6 h-28 w-28;
    }
    .button.disabled {
        @apply cursor-not-allowed;
    }
</style>
